'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_package$$anon$1() {
}
export { $c_Lcom_raquo_laminar_codecs_package$$anon$1 as $c_Lcom_raquo_laminar_codecs_package$$anon$1 };
$p = $c_Lcom_raquo_laminar_codecs_package$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_codecs_package$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_package$$anon$1() {
}
export { $h_Lcom_raquo_laminar_codecs_package$$anon$1 as $h_Lcom_raquo_laminar_codecs_package$$anon$1 };
$h_Lcom_raquo_laminar_codecs_package$$anon$1.prototype = $p;
$p.Ts = (function(domValue) {
  return (domValue !== null);
});
$p.TI = (function(scalaValue) {
  return (scalaValue ? "" : null);
});
$p.kR = (function(domValue) {
  return this.Ts(domValue);
});
$p.ie = (function(scalaValue) {
  return this.TI((!(!scalaValue)));
});
var $d_Lcom_raquo_laminar_codecs_package$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_codecs_package$$anon$1, "com.raquo.laminar.codecs.package$$anon$1", ({
  hH: 1,
  bb: 1
}));
export { $d_Lcom_raquo_laminar_codecs_package$$anon$1 as $d_Lcom_raquo_laminar_codecs_package$$anon$1 };
